import ApiService from '@/services/api.service'

const TherapyCategoriesService = {
    getAll(parameter) { 
             
        const requestData = {
            method: 'get',
            url: "/Categories/",
            headers: {},
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
        }     
        return ApiService.customRequest(requestData);         
    },
    get( id) {
        return ApiService.get(`/Categories/${id}`);
    },
    add(data){
        return ApiService.post(`/Categories`, data);
    },
    delete(Id){      
        return ApiService.delete(`/Categories/${Id}`);
    },
    update(Id,data){
        return ApiService.put(`/Categories/${Id}`,data);
    },   
   
}
  
export default TherapyCategoriesService;